import React from 'react';
import { EyeOffIcon, UsersIcon } from 'lucide-react';
import { overrideLines, payeeSummaries } from '../../data/periodClose';
import { payeeStoredTotal } from '../../utils/commission';
import { formatUsd } from '../../utils/format';
import { Card } from '../sf/Card';
import { Td, Th } from '../sf/DataTable';
import { ExampleDataBadge } from '../sf/ExampleDataBadge';
import { Money } from '../sf/Money';
import { ScopedNotification } from '../sf/ScopedNotification';
import { StoredReference } from '../sf/StoredReference';
const SCOPE = 'Arizona';
export function ManagerScopeView() {
  const people = payeeSummaries.filter(payee => payee.branch === SCOPE);
  const tlLine = overrideLines.find(line => line.branch === SCOPE && line.role === 'Team Lead');
  return <div className="space-y-3" data-id="element-928" data-mp="ckwx9fa3mahy">
      <ScopedNotification tone="info" icon={EyeOffIcon} data-id="element-929" data-mp="cjvm7at31o08">
        <strong data-id="element-930" data-mp="7lu4at7e7uqc">Scoped to Arizona only.</strong> Quinn Harper sees {people.length} employees. Other branches are hidden.
      </ScopedNotification>
      <Card title={`Arizona team · October 2026 (${people.length})`} icon={UsersIcon} iconBg="#7F8DE1" bodyClassName="" actions={<ExampleDataBadge data-id="element-932" data-mp="2xnuulxw0olww" />} data-id="element-931" data-mp="2spjnhux3wpid">
        <div className="overflow-x-auto" data-id="element-933" data-mp="32oso36mh92dp">
          <table className="w-full border-collapse" data-id="element-934" data-mp="32pu1hhqyu0yl">
            <thead data-id="element-935" data-mp="36qdvwdk5mqh1">
              <tr data-id="element-936" data-mp="36qw1w1wmcj25">
                <Th data-id="element-937" data-mp="36pciw3jkvtwo">Employee</Th>
                <Th data-id="element-938" data-mp="36pkvrvfpaz7v">Role</Th>
                <Th align="right" data-id="element-939" data-mp="2a03lt49oqr0d">Units</Th>
                <Th align="right" data-id="element-940" data-mp="2a1elot00fem7">Volume</Th>
                <Th align="right" data-id="element-941" data-mp="29yadlkjfbyq9">Adjusted (pays)</Th>
                <Th align="right" className="font-normal" data-id="element-942" data-mp="2ezzngwuwu6cr">
                  Stored (unadjusted) – reference
                </Th>
              </tr>
            </thead>
            <tbody data-id="element-943" data-mp="2ns1l6ndlh8jc">
              {people.map(person => <tr key={person.id} data-id="element-944" data-mp="2ntmhoijgz1ju">
                  <Td className="font-semibold" data-id="element-945" data-mp="1ra5dqo5w0xwq">{person.name}</Td>
                  <Td className="text-sf-weak" data-id="element-946" data-mp="1r7swkd7yerkq">{person.role}</Td>
                  <Td align="right" data-id="element-947" data-mp="1v9w8f2yjby6j">{person.units}</Td>
                  <Td align="right" data-id="element-948" data-mp="2yluy9gkkp4or">{formatUsd(person.volume)}</Td>
                  <Td align="right" className="font-semibold" data-id="element-949" data-mp="2yk1pnvqegae4">
                    <Money value={person.adjustedTotal} data-id="element-950" data-mp="2tm0a3ks6mt7e" />
                  </Td>
                  <Td align="right" data-id="element-951" data-mp="38cfsysx4lp2e">
                    <StoredReference value={payeeStoredTotal(person)} compact data-id="element-952" data-mp="38bekmw7hvgod" />
                  </Td>
                </tr>)}
            </tbody>
          </table>
        </div>
        {tlLine && <p className="border-t border-sf-border px-4 py-2.5 text-xs text-sf-weak" data-id="element-953" data-mp="2fninxrhxdorl">
            TL row for {tlLine.name}: {formatUsd(tlLine.adjustedVolume)} adjusted volume × {tlLine.bps} bps = <span className="font-semibold text-sf-text" data-id="element-954" data-mp="2opi7aqgex4xp">{formatUsd(tlLine.adjustedAmount)}</span> –
            from employee record: {tlLine.bpsField} · Bonus: none
          </p>}
      </Card>
    </div>;
}